import React, { useState } from "react";
import { Download, HeartHandshake } from "lucide-react";
import { useApi } from "../hooks/useApi";
import { downloadPdf } from "./FileUpload";
import { Button } from "./ui/button";

export function WelfarePayoutReport() {
  const thisYear = new Date().getFullYear();
  const [year, setYear] = useState(thisYear);
  const { data } = useApi(`/admin/welfare/payout-report?year=${year}`, [year]);
  const years = [thisYear, thisYear - 1, thisYear - 2, thisYear - 3];
  return (
    <div className="mt-8" data-testid="welfare-payout-report">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h3 className="font-serif-display text-xl font-bold text-crimson flex items-center gap-2"><HeartHandshake size={18} className="text-gold" /> Welfare paid out by claim type</h3>
        <div className="flex items-center gap-2">
          <select value={year} onChange={(e) => setYear(Number(e.target.value))} className="h-8 rounded-md border border-gold/40 bg-white px-2 text-sm" data-testid="payout-report-year">{years.map((y) => <option key={y} value={y}>{y}</option>)}</select>
          <Button size="sm" variant="outline" className="gap-1" onClick={() => downloadPdf(`/admin/welfare/payout-report.csv?year=${year}`, `welfare-payouts-${year}.csv`)} data-testid="payout-report-export"><Download size={14} /> CSV</Button>
        </div>
      </div>
      <div className="mt-3 glass overflow-x-auto rounded-2xl">
        <table className="w-full text-sm"><thead className="bg-crimson text-parchment"><tr>
          <th className="p-3 text-left">Claim type</th><th className="p-3 text-right">Claims</th><th className="p-3 text-right">Payouts</th><th className="p-3 text-right">Amount paid</th></tr></thead>
          <tbody>
            {(data?.by_type || []).map((r) => (
              <tr key={r.type} className="border-b border-gold/15" data-testid={`payout-type-${r.type}`}>
                <td className="p-3 capitalize">{r.type.replace(/_/g, " ")}</td><td className="p-3 text-right font-mono-accent">{r.claims}</td><td className="p-3 text-right font-mono-accent">{r.payouts}</td><td className="p-3 text-right font-mono-accent">${r.amount.toFixed(2)}</td>
              </tr>
            ))}
            {data && data.by_type.length === 0 && <tr><td className="p-3 text-muted-foreground" colSpan={4}>No welfare payouts recorded for {year}. Use "Record payment" on approved claims in Welfare Review.</td></tr>}
            {data && data.total > 0 && <tr className="bg-gold-light font-semibold"><td className="p-3">Total paid out {year}</td><td /><td className="p-3 text-right font-mono-accent">{data.payout_count}</td><td className="p-3 text-right font-mono-accent" data-testid="payout-report-total">${data.total.toFixed(2)}</td></tr>}
          </tbody>
        </table>
      </div>
      <p className="mt-1 text-xs text-muted-foreground">This table is also included in the AGM PDF pack (section 5b).</p>
    </div>
  );
}
